

























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalMixins from '../mixins';

import OptionsHeader from '@/components/OptionsHeader.vue'
import { IParty } from '../interfaces';

@Component({
	components: {
		OptionsHeader
	}
})
export default class SelectParties extends GlobalMixins {
	selectedParties: number[] = []
	
	get allSelected(): boolean {
		let maxSelectableParties = 0 

		Object.keys(this.participatingPartiesColumns).forEach(location => {
			this.participatingPartiesColumns[(location as 'left' | 'center' | 'right')].forEach(party => {
				maxSelectableParties++
			})
		})

		return (this.selectedParties.length === maxSelectableParties)
	}
	get allSittingSelected(): boolean {
		let onlyAllSittingSelected = true 

		Object.keys(this.participatingPartiesColumns).forEach(location => {
			this.participatingPartiesColumns[(location as 'left' | 'center' | 'right')].forEach((party, index) => {
				if (party.hasSeats) {
					let partySelected = false

					this.selectedParties.forEach(selectedPartyId => {
						if (party.id === selectedPartyId) partySelected = true
					})

					if (!partySelected) onlyAllSittingSelected = false
				} else {
					this.selectedParties.forEach(selectedPartyId => {
						if (party.id === selectedPartyId) onlyAllSittingSelected = false
					})
				}
			})
		})

		return onlyAllSittingSelected
	}
	get nextButtonDisabled(): boolean {
		return (this.selectedParties.length < (this.config.settings.minimumSelectedParties ? this.config.settings.minimumSelectedParties : 3))
	}
	get participatingPartiesColumns(): {left: IParty[], center: IParty[], right: IParty[]} {
		const parties: any = this.parties.filter(party => {
			return party.participates
		})
		const partiesPerColumn = Math.ceil(parties.length / 3)
		let sortedParties: any = [[], [], []]

		for (let column = 0; column < 3; column++) {
			for (let i = 0; i < partiesPerColumn; i++) {
				const value = parties[i + column * partiesPerColumn]

				if (!value) continue

				sortedParties[column].push(value)
			}
		}

		sortedParties = {
			left: sortedParties[0],
			center: sortedParties[1],
			right: sortedParties[2]
		}

		return sortedParties
	}

	@Watch('selectedParties')
	onSelectedPartiesChange() {
		this.$store.dispatch('setSelectedParties', this.selectedParties.length === 0 ? false : this.selectedParties)
	}

	toggleParty(party: IParty, location: string, index: number): void {
		if (this.selectedParties.indexOf(party.id) === -1) {
			this.selectedParties.push(party.id)
		} else {
			this.selectedParties.splice(this.selectedParties.indexOf(party.id), 1)
		}
	}
	isSelectedParty(party: IParty, location: string, index: number): boolean {
		return this.selectedParties.indexOf(party.id) !== -1
	}
	toggleAll() {
		if (this.allSelected) {
			this.selectedParties = []
		} else {
			Object.keys(this.participatingPartiesColumns).forEach(location => {
				this.participatingPartiesColumns[(location as 'left' | 'center' | 'right')].forEach((party, index) => {			
					if (this.selectedParties.indexOf(party.id) === -1) {
						this.selectedParties.push(party.id)
					}
				})
			})
		}
	}
	toggleSitting() {
		if (this.allSittingSelected) {
			this.selectedParties = []
		} else {
			Object.keys(this.participatingPartiesColumns).forEach(location => {
				this.participatingPartiesColumns[(location as 'left' | 'center' | 'right')].forEach((party, index) => {			
					if (this.selectedParties.indexOf(party.id) === -1) {
						if (!party.hasSeats) return

						this.selectedParties.push(party.id)
					} else {
						if (!party.hasSeats) this.selectedParties.splice(this.selectedParties.indexOf(party.id), 1)
					}
				})
			})
		}
	}
	next() {
		if (this.nextButtonDisabled) return

		if (!this.$store.getters.showAnalyticsQuestion) {
		  this.trackGAEvent('results')
		}

		this.$router.push({ name: (this.$store.getters.showAnalyticsQuestion ? 'select-analytics' : 'results') })
	}

	created() {
		if (this.user.selectedParties && this.user.selectedParties.length) {
			this.selectedParties = this.user.selectedParties
		}
	}
}
